export default __webpack_public_path__ + "static/Header Image Placeholder-9dd7b70ab579170a6226a5acaf6fae34.jpg";